import actionCreatorFactory from 'typescript-fsa';

import { User } from '@topconagriculture/frontend-utils';

import reduxConfig from '../../config';
import { UserPayload } from './company.user.reducer';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/user');

export const getCompanyUserList = actionCreator.async<{}, User[]>('GET_COMPANY_USER_LIST');
export const createCompanyUser = actionCreator.async<UserPayload, {}>('CREATE_COMPANY_USER');
